<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      fill-rule="evenodd"
      d="M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm11-9a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9Zm-1.008 5a1 1 0 0 1 1-1h.009a1 1 0 1 1 0 2h-.009a1 1 0 0 1-1-1Zm.932 2.027c.247.033.587.122.877.41l.005.004c.288.29.376.631.409.878.027.204.027.442.027.642V17a1 1 0 1 1-2 0v-5a1 1 0 1 1 0-2h.04c.2 0 .437 0 .642.027Zm-.262 1.983h-.002.002Zm-.43-.428v-.002.002Z"
      clip-rule="evenodd"
    />
  </svg>
</template>
